// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--tQV0hgp2VgerDlrx","textWrapper":"text-wrapper--qnabO5D4zoeMvTXW"};